import { useQuery } from "@tanstack/react-query";

import { useOptionalAssetInventoryApi } from "../../api/ClientFileApiContext";
import { ClientFileQueryKey } from "../../query/clientFileQueryKeys";

export function useAssetInventoryCompleteness(clientId: string | undefined) {
  const assetInventoryApi = useOptionalAssetInventoryApi();

  return useQuery({
    queryKey: [ClientFileQueryKey.AssetInventoryCompleteness, clientId],
    queryFn: () => {
      if (!clientId || !assetInventoryApi) {
        throw new Error("Client ID and the asset inventory API are required");
      }
      return assetInventoryApi.getAssetInventoryCompleteness({ clientId });
    },
    enabled: !!clientId && !!assetInventoryApi,
  });
}
